import { takeLatest, takeEvery, call, put, fork, select } from 'redux-saga/effects'
import featureToggles from 'shared/featureToggles'
import { indicateProgress } from 'api'
import * as entities from 'entities'
import * as auth from 'auth'
import { getCurrentUserSaga } from 'auth/sagas'

import { apiLanguageCodeSelector } from 'i18n/selectors'

import * as constants from 'credit-cards/constants'
import * as actions from 'credit-cards/actions'
import * as grsApi from 'credit-cards/grsApi'
import * as nAmApi from 'credit-cards/nAmApi'

import { rootSaga as ingenicoRootSaga } from 'credit-cards/ingenico'
import { rootSaga as monerisRootSaga } from 'credit-cards/moneris'
import { rootSaga as pagseguroRootSaga } from 'credit-cards/pagseguro'
import { rootSaga as nuveiRootSaga } from 'credit-cards/nuvei'

const pspSagas = {
    INGENICO: ingenicoRootSaga,
    MONERIS: monerisRootSaga,
    PAGSEGURO: pagseguroRootSaga,
    NUVEI: nuveiRootSaga,
}

const pspRootSaga = pspSagas[window.PAYMENT_SERVICE_PROVIDER]

function* removeCreditCardSaga() {
    yield takeLatest(constants.REMOVE_CREDIT_CARD, function* ({ creditCard }) {
        try {
            yield indicateProgress(['removeCreditCard', `removeCreditCard-${creditCard.id}`], function* () {
                if (featureToggles.newAuthFlow) {
                    const { token, accountKey } = yield select(auth.selectors.userSelector)
                    yield call(nAmApi.removeCreditCard, accountKey, token, creditCard.id)
                } else {
                    yield call(grsApi.removeCreditCard, creditCard)
                }
                yield getCurrentUserSaga()
            })
        } catch (e) {}
    })
}

function* setDefaultCreditCardSaga() {
    yield takeLatest(constants.SET_DEFAULT_CREDIT_CARD, function* ({ creditCard }) {
        try {
            yield indicateProgress(['setDefaultCard', `setDefaultCard-${creditCard.id}`], function* () {
                const apiLanguageCode = yield select(apiLanguageCodeSelector)
                const { accountKey, token } = yield select(auth.selectors.userSelector)

                if (featureToggles.newAuthFlow) {
                    yield call(nAmApi.setDefaultCreditCard, accountKey, token, creditCard.id)
                } else {
                    yield call(grsApi.setDefaultCreditCard, token, creditCard, apiLanguageCode)
                }
                yield getCurrentUserSaga()
            })
        } catch (e) {}
    })
}

export function* clearCreditCardsSaga() {
    yield takeEvery(auth.constants.LOGOUT, function* () {
        yield put(entities.actions.clearEntity(auth.schemas.creditCardSchema.key))
    })
}

function* updateCreditCardList() {
    yield takeLatest(constants.ADD_PAYMENT_METHOD_SUCCESS, function* () {
        yield getCurrentUserSaga()
    })
}

export function* getPSEPaymentBanksSaga() {
    try {
        const result = yield call(indicateProgress, 'getPSEPaymentBanks', grsApi.getPseBanks)
        yield put(actions.setPSEPaymentBanks(result?.merchantPaymentBanks))
    } catch (exception) {}
}

export function* rootSaga() {
    yield fork(removeCreditCardSaga)
    yield fork(setDefaultCreditCardSaga)
    yield fork(clearCreditCardsSaga)
    yield fork(updateCreditCardList)
    yield takeLatest(constants.GET_PSE_PAYMENT_BANKS, getPSEPaymentBanksSaga)

    if (pspRootSaga) yield fork(pspRootSaga)
}
